<template>
  <contact-form-fieldset :legend="texts.howCanWeHelp" :required="true">
    <competence-type-select
      :contact-type="requestType"
      :empty-value="texts.howCanWeHelp"
      :options="options"
      @change="updateCaseType"
    />
  </contact-form-fieldset>
</template>

<script>
import CompetenceTypeSelect from 'Main/components/CompetenceTypeSelect.vue';
import ContactFormFieldset from 'Main/contact-form/components/ContactFormFieldset.vue';

export default {
  name: 'CompetenceType',

  components: {
    CompetenceTypeSelect,
    ContactFormFieldset,
  },

  props: {
    requestType: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      texts: theme_vars.contactTexts,
    };
  },

  methods: {
    updateCaseType(value) {
      this.$emit('update-case-type', value);
    },
  },
};
</script>
